// WARNING: This file is auto-generated. Do not edit directly.
import { semanticTokensHr } from './semantic.hr';
import { semanticTokensBo } from './semantic.bo';
import { semanticTokensEmployee } from './semantic.employee';
import { semanticTokensMerchant } from './semantic.merchant';
import type { SemanticTokens } from './types';

export function buildComponentSpecificTokens(semantic: SemanticTokens) {
  return {
    button: {
      primary: {
        default: {
          default: semantic.surface.background.brand.default.base,
          hover: semantic.surface.background.brand.default.subtle,
          pressed: semantic.surface.background.brand.default.highlighted,
          disabled: semantic.surface.background.neutral.default.disabled,
          content: {
            default: semantic.content.onBrand.default,
            disabled: semantic.content.disabled.default,
          },
        },
        danger: {
          default: semantic.danger.base,
          hover: semantic.danger.subtle,
          pressed: semantic.danger.highlighted,
          disabled: semantic.surface.background.neutral.default.disabled,
          content: {
            default: semantic.content.static.onInverse,
            disabled: semantic.content.disabled.default,
          },
        },
        onBrand: {
          default: semantic.surface.background.brand.default.muted,
          hover: semantic.surface.background.brand.default.pale,
          pressed: semantic.surface.background.brand.default.highlighted,
          disabled: semantic.surface.background.brand.default.subtle,
          content: {
            default: semantic.content.default.default,
            hover: semantic.content.default.default,
            pressed: semantic.content.onBrand.default,
            disabled: semantic.content.disabled.onInverse,
          },
        },
      },
      secondary: {
        default: {
          border: {
            default: semantic.border.neutral.default.base,
            disabled: semantic.border.neutral.default.disabled,
          },
          fill: {
            hover: semantic.surface.background.neutral.default.raised,
            pressed: semantic.surface.background.neutral.default.idle,
          },
          content: {
            default: semantic.content.default.default,
            disabled: semantic.content.disabled.default,
          },
        },
        danger: {
          border: {
            default: semantic.danger.base,
            disabled: semantic.border.neutral.default.disabled,
          },
          fill: {
            hover: semantic.danger.muted,
            pressed: semantic.danger.pale,
          },
          content: {
            default: semantic.danger.base,
            disabled: semantic.content.disabled.default,
          },
        },
        onBrand: {
          content: {
            default: semantic.content.onBrand.default,
            disabled: semantic.content.disabled.onInverse,
          },
          border: {
            default: semantic.border.onBrand.default,
            disabled: semantic.border.onBrand.disabled,
          },
          fill: {
            hover: semantic.surface.background.brand.default.subtle,
            pressed: semantic.surface.background.brand.default.highlighted,
          },
        },
      },
      iconButton: {
        default: {
          border: {
            default: semantic.border.neutral.default.base,
            disabled: semantic.border.neutral.default.disabled,
          },
          fill: {
            hover: semantic.surface.background.neutral.default.raised,
            pressed: semantic.surface.background.neutral.default.idle,
          },
          content: {
            default: semantic.content.default.default,
            disabled: semantic.content.disabled.default,
          },
        },
        danger: {
          border: {
            default: semantic.danger.base,
            disabled: semantic.border.neutral.default.disabled,
          },
          fill: {
            hover: semantic.danger.muted,
            pressed: semantic.danger.pale,
          },
          content: {
            default: semantic.danger.base,
            disabled: semantic.content.disabled.default,
          },
        },
        onBrand: {
          content: {
            default: semantic.content.onBrand.default,
            disabled: semantic.content.disabled.onInverse,
          },
          border: {
            default: semantic.border.onBrand.default,
            disabled: semantic.border.onBrand.disabled,
          },
          fill: {
            hover: semantic.surface.background.brand.default.subtle,
            pressed: semantic.surface.background.brand.default.highlighted,
          },
        },
      },
      textButton: {
        default: {
          content: {
            default: semantic.content.action.base,
            disabled: semantic.content.disabled.default,
          },
          fill: {
            hover: semantic.surface.background.brand.default.muted,
            pressed: semantic.surface.background.brand.default.pale,
          },
        },
        secondary: {
          content: {
            default: semantic.content.default.default,
            disabled: semantic.content.disabled.default,
          },
          fill: {
            hover: semantic.surface.background.neutral.default.raised,
            pressed: semantic.surface.background.neutral.default.idle,
          },
        },
        danger: {
          content: {
            default: semantic.danger.base,
            disabled: semantic.content.disabled.default,
          },
          fill: {
            hover: semantic.danger.muted,
            pressed: semantic.danger.pale,
          },
        },
        onBrand: {
          content: {
            default: semantic.content.onBrand.default,
            disabled: semantic.content.disabled.onInverse,
          },
          fill: {
            hover: semantic.surface.background.brand.default.subtle,
            pressed: semantic.surface.background.brand.default.highlighted,
          },
        },
      },
      inlineButton: {
        default: {
          default: semantic.content.action.base,
          hover: semantic.content.action.subtle,
          pressed: semantic.content.action.highlighted,
          disabled: semantic.content.disabled.default,
        },
        secondary: {
          default: semantic.content.default.default,
          hover: semantic.content.muted.default,
          pressed: semantic.content.default.default,
          disabled: semantic.content.disabled.default,
        },
        danger: {
          default: semantic.danger.base,
          hover: semantic.danger.subtle,
          pressed: semantic.danger.highlighted,
          disabled: semantic.content.disabled.default,
        },
        onBrand: {
          default: semantic.content.onBrand.default,
          hover: semantic.content.onBrand.default,
          pressed: semantic.content.onBrand.default,
          disabled: semantic.content.disabled.onInverse,
        },
      },
    },
    badge: {
      neutral: semantic.surface.background.neutral.default.raised,
      yellow: semantic.accent.yellow.default.muted,
      indaco: semantic.accent.indaco.default.muted,
      green: semantic.accent.green.default.muted,
      violet: semantic.accent.violet.default.muted,
      sand: semantic.accent.sand.default.muted,
    },
    link: {
      default: {
        default: semantic.content.action.base,
        hover: semantic.content.action.subtle,
        pressed: semantic.content.action.highlighted,
        disabled: semantic.content.disabled.default,
      },
      secondary: {
        default: semantic.content.default.default,
        hover: semantic.content.muted.default,
        pressed: semantic.content.subtle.default,
        disabled: semantic.content.disabled.default,
      },
    },
  } as const;
}

export const componentSpecificTokensHr =
  buildComponentSpecificTokens(semanticTokensHr);
export const componentSpecificTokensBo =
  buildComponentSpecificTokens(semanticTokensBo);
export const componentSpecificTokensEmployee = buildComponentSpecificTokens(
  semanticTokensEmployee,
);
export const componentSpecificTokensMerchant = buildComponentSpecificTokens(
  semanticTokensMerchant,
);
export type ComponentSpecificTokens = typeof componentSpecificTokensHr;
